import { type ReactNode, useState } from "react";
import { MenuIcon, XIcon } from "lucide-react";
import { AdminSidebar } from "./AdminNav";

// The admin work portal chrome: a fixed left sidebar on desktop (content shifted right by its
// width) and a slide-in drawer on mobile (toggled from a slim top bar). Full-page content, not a
// centered max-width body, so the admin has room to actually work in tables and overviews.
export function AdminShell({ children }: { children: ReactNode }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop sidebar: fixed, full height. */}
      <div className="fixed inset-y-0 left-0 z-30 hidden w-60 md:block">
        <AdminSidebar />
      </div>

      {/* Mobile drawer. */}
      {drawerOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setDrawerOpen(false)} />
          <div className="absolute inset-y-0 left-0 w-64 shadow-xl">
            <AdminSidebar onNavigate={() => setDrawerOpen(false)} />
            <button
              type="button"
              onClick={() => setDrawerOpen(false)}
              aria-label="Menu sluiten"
              className="absolute right-2 top-3 flex size-8 cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"
            >
              <XIcon className="size-5" />
            </button>
          </div>
        </div>
      )}

      {/* Content, shifted right of the fixed sidebar on desktop. */}
      <div className="flex min-h-screen flex-col md:pl-60">
        {/* Mobile top bar with the menu toggle. */}
        <div className="flex items-center gap-3 border-b border-border px-4 py-3 md:hidden">
          <button
            type="button"
            onClick={() => setDrawerOpen(true)}
            aria-label="Menu openen"
            className="flex size-9 cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"
          >
            <MenuIcon className="size-5" />
          </button>
          <span className="flex items-center gap-2 text-sm font-semibold text-foreground">
            <img src="/favicon.png" alt="" className="size-5 shrink-0" />
            Mijn KUVO Woerden
          </span>
        </div>

        <main className="flex-1 px-5 py-6 sm:px-6 lg:px-8">{children}</main>
      </div>
    </div>
  );
}
